import { useFeature } from '@/apiHooks/featureSwitches.hook';
import { Feature } from '@/@types/featureSwitch';
import { isFeatureFlagEnabled } from '@/utils/isFeatureFlagEnabled.util';

export const useVoucherEligibility = () => {
  const isEligible =
    useFeature(Feature.WOMENS_DAY_VOUCHER_MODAL) || isFeatureFlagEnabled(Feature.WOMENS_DAY_VOUCHER_MODAL);

  return {
    isEligible,
  };
};
